import o from "./highrise247.mjs";
/* empty css             */
/* empty css             */
import r from "./highrise181.mjs";
const f = /* @__PURE__ */ r(o, [["__scopeId", "data-v-f73c0742"]]);
export {
  f as default
};
